import Bugsnag from "@bugsnag/js";
import { NotifiableError } from "@bugsnag/core/types/common";
import { isNullOrUndefOrEmpty } from "@civicscience/chops";

type ErrorReportMetaData = {
  name: string;
  metaData: Record<string, string>;
};

/**
 * Used to report a _handled_ error to BugSnag,
 * For example:
 *
 * ```
 * try {
 *   // Some potentially crashy code
 * } catch (e) {
 *    Bugsnag.notify(e);
 * }
 * ```
 *
 * See the docs for more details:
 * https://docs.bugsnag.com/platforms/javascript/react/reporting-handled-errors/
 *
 * Note that we accept `unknown` as a possible input to this function (which basically allows anything).
 * BugSnag does provide the `NotifiablError` type, but most of our errors are typed as unknown so this
 * is more convenient for us. The BugSnag docs (linked above) do mention they will try to work
 * with any shape that you provide them.
 */
export const reportError = (err: NotifiableError | unknown, errorReportMetaData?: ErrorReportMetaData[]) => {
  Bugsnag.notify(err as NotifiableError, function (event) {
    if (!isNullOrUndefOrEmpty(errorReportMetaData)) {
      errorReportMetaData.forEach((data) => {
        event.addMetadata(data.name, data.metaData);
      });
    }
  });
};
